import {
    ADD_FAVOURITE_TEAM_SUCCESS,
    FETCH_ALL_TEAM_SUCCESS,
    FETCH_TEAM_SUCCESS,
    FILTER_TEAM,
    GET_ALL_TEAM,
    GET_UNSELECTED_ALL_TEAM,
    HANDLE_TEAM_REQUEST_CLOSE,
    HIDE_TEAM_LOADER,
    SHOW_TEAM_LOADER,
    ON_ADD_TEAM,
    ON_EDIT_TEAM,
    ON_ALL_TEAM_SELECT,
    ON_TEAM_CLOSE,
    ON_TEAM_SELECT,
    ON_DELETE_TEAM_SUCCESS,
    ON_FILTER_SELECTED_TEAM,
    ON_FILTER_TEAM_OPTION_SELECT,
    ON_SAVE_TEAM_SUCCESS,
    ON_TOGGLE_TEAM_DRAWER,
    SHOW_TEAM_MESSAGE,
    UPDATE_SEARCH_TEAM,
    SET_TEAM,
    CLEAR_SESSION,
    ON_FETCH_SELECT_MEMBER_DATA_SUCCESS,
    CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const ALL_FILTER = 'All teams';
export const STARRED_FILTER = 'Starred teams';
export const SUCCESSFUL_UPDATE = 'Team Updated Successfully';
export const SUCCESSFUL_FILTER = 'Team Filtered Successfully';
export const SUCCESSFUL_DELETE = 'Team Deleted Successfully';
export const REMOVED_AS_STAR = 'Team removed as star';
export const MARKED_AS_STAR = 'Team marked as star';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No teams found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: ALL_FILTER,
    allTeam: [],
    teamList: [],
    selectedTeam: null,
    selectedTeams: 0,
    addTeamState: false,
    editTeamState: false,
    searchTeam: '',
    memberSelectionList: [],
    selectedMembers: 0,
    team: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedTeam: null,
            };
        }
        case ON_FETCH_SELECT_MEMBER_DATA_SUCCESS: {
            return {
                ...state,
                memberSelectionList: action?.payload,
                loader: false,
            };
        }
        case SET_TEAM: {
            const teams = state.allTeam.filter((entry) => entry?.id === action?.payload);
            return {
                ...state,
                loader: false,
                selectedTeam: teams?.length > 0 ? teams[0] : [],
            };
        }
        case ADD_FAVOURITE_TEAM_SUCCESS: {
            const allUpdated = state.allTeam.map((entry) => entry?.id === action?.payload?.id ? {
                ...entry,
                starred: !action?.payload?.starred
            } : entry);
            let listUpdated = {};
            switch (state.filterOption) {
                case ALL_FILTER: {
                    listUpdated = allUpdated;
                    break;
                }
                case STARRED_FILTER: {
                    listUpdated = allUpdated.filter((entry) => entry.starred);
                    break;
                }
            }
            return {
                ...state,
                alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
                showMessage: true,
                teamList: listUpdated,
                allTeam: allUpdated,
            };
        }
        case FETCH_TEAM_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedTeam: action.payload,
                addTeamState: false,
                editTeamState: false,
            };
        }
        case FETCH_ALL_TEAM_SUCCESS: {
            return {
                ...state,
                loader: false,
                allTeam: action.payload,
                teamList: action.payload,
                selectedSectionId: 1,
                searchEmp: '',
                filterOption: ALL_FILTER,
                addTeamState: false,
                editTeamState: false,
            };
        }
        case SHOW_TEAM_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_TEAM_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedMembers = 0;
            const memberSelectionList = state.memberSelectionList.map(member => {
                if (member.selected) {
                    selectedMembers++;
                }
                if (member.id === action.payload.id) {
                    if (member.selected) {
                        selectedMembers++;
                    }
                    return action.payload;
                } else {
                    return member;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedMembers: selectedMembers,
                memberSelectionList: memberSelectionList
            };
        }
        case ON_ADD_TEAM: {
            return {
                ...state,
                addTeamState: true,
                editTeamState: false,
            };
        }
        case ON_EDIT_TEAM: {
            return {
                ...state,
                selectedTeam: action.payload,
                editTeamState: true,
                addTeamState: false,
            };
        }
        case ON_TEAM_CLOSE: {
            return {
                ...state,
                addTeamState: false,
                editTeamState: false,
            };
        }
        case ON_FILTER_TEAM_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let teamList = [];
            switch (action.payload.name) {
                case ALL_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    teamList = state.allTeam;
                    break;
                }
                case STARRED_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    teamList = state.allTeam.filter((team) => team.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, teamList, drawerState: false
            };
        }
        case ON_SAVE_TEAM_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_UPDATE,
                showMessage: true,
                teamList: addOrUpdateEntry(state.teamList, action.payload),
                allTeam: addOrUpdateEntry(state.allTeam, action.payload),
                selectedTeam: action.payload,
                loader: false,
            };
        }
        // called after a delete from the db operation to keep the current state up to date
        case ON_DELETE_TEAM_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_DELETE,
                showMessage: true,
                allTeam: state.allTeam.filter((team) => team.id !== action.payload),
                teamList: state.allTeam.filter((team) => team.id !== action.payload),
                selectedTeam: null,
            };
        }
        case ON_FILTER_SELECTED_TEAM: {
            const teams = state.allTeam.filter((team) => !team.selected);
            return {
                ...state,
                alertMessage: SUCCESSFUL_FILTER,
                showMessage: true,
                teamList: teams,
                selectedTeams: 0
            };
        }
        case FILTER_TEAM: {
            const { filterOption } = state;
            let teamList = [];
            if (action.payload === '') {
                teamList = state.allTeam;
            } else {
                const filterTeam = state.allTeam.filter((team) =>
                    team.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === ALL_FILTER) {
                    teamList = filterTeam;
                } else if (filterOption === STARRED_FILTER) {
                    teamList = filterTeam.filter((team) => team.starred);
                }
            }
            return { ...state, teamList: teamList };
        }
        case GET_ALL_TEAM: {
            let teamList = state.allTeam.map((team) => team ? {
                ...team,
                selected: true
            } : team);
            return {
                ...state,
                selectedTeams: teamList.length,
                allTeam: teamList,
                teamList: teamList
            };
        }
        case GET_UNSELECTED_ALL_TEAM: {
            let teamList = state.allTeam.map((team) => team ? {
                ...team,
                selected: false
            } : team);
            return {
                ...state,
                selectedTeams: 0,
                allTeam: teamList,
                teamList: teamList
            };
        }
        case ON_ALL_TEAM_SELECT: {
            const selectAll = state.selectedTeams < state.teamList.length;
            let selectedTeams = 0;
            let teamList = [];
            if (selectAll) {
                teamList = state.allTeam.map((team) => team ? {
                    ...team,
                    selected: true
                } : team);
                selectedTeams = teamList.length;
            } else {
                teamList = state.allTeam.map((team) => team ? {
                    ...team,
                    selected: true
                } : team);
                selectedTeams = 0;
            }
            return {
                ...state,
                selectedTeams: selectedTeams,
                allTeam: teamList,
                teamList: teamList
            };
        }
        case UPDATE_SEARCH_TEAM: {
            return { ...state, searchTeam: action.payload };
        }
        case HANDLE_TEAM_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_TEAM_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_TEAM_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_TEAM_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/team.js